@if (product$ | async; as product) {
  <div class="product-summary">
    @if (isLoggedIn$ | async) {
      <ng-template [cxOutlet]="outlets.PRICE" [cxOutletContext]="{ product: product }">
        @if (userPermissionService.showPrice) {
          <div class="price" aria-label="new item price">
            {{ product?.price?.formattedValue }} <span class="product-summary__uom"> per {{ product?.unit?.name }}</span>
          </div>
        }
      </ng-template>
    }
    <ng-template [cxOutlet]="outlets.SUMMARY" [cxOutletContext]="{ product: product }">
      <p [innerHTML]="product?.summary" class="summary"></p>
    </ng-template>
    @if (product?.videoURL) {
      <div class="product-summary__product-video">
        <p (click)="open(product)">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-play-fill"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            >
            <path
              d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"
              />
            </svg>
            <span>Watch Product Video</span>
          </p>
        </div>
      }
    </div>
  }
